/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Container } from 'app/components';
import { getContainersInnerHTML } from 'utils';
import {
  SectionInfo,
  SectionInfoTitle,
  SectionInfoContent,
  SectionInfoContentInner
} from '../styles';

const propTypes = {
  content: PropTypes.string,
  fetchContent: PropTypes.func.isRequired
};

const defaultProps = {
  content: null
};

const Impressum = ({ content, fetchContent }) => {
  const [t] = useTranslation();

  useEffect(() => {
    if(!content) {
      fetchContent()
    }
  }, []);

  return (
    <SectionInfo>
      <Container>
        <SectionInfoTitle>{t('common.impressum')}</SectionInfoTitle>
        <SectionInfoContent>
          {content ? (
            <SectionInfoContentInner
              dangerouslySetInnerHTML={{ __html: getContainersInnerHTML(content) }}
            />
          ) : (
            <p>{t('info.no_info')}</p>
          )}
        </SectionInfoContent>
      </Container>
    </SectionInfo>
  );
};

Impressum.propTypes = propTypes;
Impressum.defaultProps = defaultProps;
export default Impressum;
